import Button from '@/components/UI/Button/Button';
import styles from './HomeSection.module.css';
import { useNavigate } from 'react-router-dom';

interface CatalogoProps {
	className?: string;
	title: string;
	description: string;
	description2: string;
	btnText: string;
	backgroundImg: string;
	imgLeftPosition: boolean;
	linkTo: string;
	bright: boolean;
}

const HomeSection = (props: CatalogoProps) => {
	const navigate = useNavigate();

	return (
		<div className={styles.main_container}>
			<div className={`${styles.container} ${props.imgLeftPosition ? styles.reverse : ''}`}>
				{/* Descrizione */}
				<div className={`${styles.content} ${props.bright ? '' : styles.light_content}`}>
					<div className={`${styles.title} ${props.bright ? styles.title_dark : ''}`}>{props.title}</div>
					<div className={`${styles.description} ${props.bright ? '' : styles.light_content}`}>
						<span>
							<p>{props.description}</p>
							<p>{props.description2}</p>
						</span>
					</div>
					<div>
						<Button
							className={styles.btn}
							name={props.btnText}
							onClick={() => navigate(props.linkTo)}
							typeSubmit={'button'}
							color={props.bright ? 'white' : 'black'}
							background={props.bright ? 'white' : 'black'}
						/>
					</div>
				</div>

				{/* Immagine */}
				<div className={styles.imgContainer}>
					<img className={styles.section_img} src={props.backgroundImg} alt={props.title} />
				</div>
			</div>
		</div>
	);
};

export default HomeSection;
